import React from 'react'
import '../Assests/css/studentApplication.css'
import educatorimage from '../Assests/images/educator_image.jpg'
import { Link } from 'react-router-dom'
import helpers from '../utils/helpers'
import fallBackImage from '../Assests/images/placeholderimage.jpg'
import toast from 'react-hot-toast'


export default function StudentApplicationCard({ item, permission, userRole }) {
    let cryptId = helpers.encryptId(item?.application_id)
    const alertPermission = () => {
        if (userRole?.role_name == 'Student') {
            toast.error('You donot have permission to view this page, please contact your educator regarding this.')
        } else {
            toast.error('You donot have permission to view this page, please contact to educator regarding this.')
        }
    }
    return (
        <>
            {permission?.view === true ?
                <Link to={`/myapplications/${cryptId}`} >
                    <div className='student_application_card_inner'>
                        <div className='card-body'>
                            <div className='student_application_details'>
                                <div className='student_details'>
                                    <div className='student_subject_icon w-32 h-18'>
                                        <img src={item?.icon || fallBackImage} alt={item?.name} className='w-18 h-18 object-cover rounded rounded-lg'
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = fallBackImage;
                                            }}
                                        />
                                    </div>
                                    <div className='student_subject_details'>
                                        <h4>{item?.name}</h4>
                                        <p>{item?.subject_name}</p>
                                        <p>Location: {item?.location}</p>
                                        <p>Usage Hour: {item?.simulated_usage_hour}</p>
                                    </div>
                                </div>
                                <div>
                                    <div className='student_educator_details'>
                                        <div className='educator_image_sec w-10 h-10'>
                                            <img src={item?.profile_pic} alt='Image' className='w-10 h-10 object-cover rounded-full' />
                                        </div>
                                        <div className='educator_detail_sec'>
                                            <h4>{item?.createdBy}</h4>
                                            <p>ID: {item?.educator_id}</p>
                                        </div>
                                    </div>
                                    {item?.simulated_grade_type &&
                                        <div className='student_grade_sec'>
                                            <p>{item?.simulated_grade_type}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className='student_progressBar_sec'>
                                <div className='student_check_application' style={{ justifyContent: item?.simulated_session_length_minutes ? 'space-between' : 'end' }}>
                                    {item?.simulated_session_length_minutes && <p>Session Length: {item?.simulated_session_length_minutes}</p>}
                                    <p>{item?.simulated_completion_percentage}% Complete</p>
                                </div>
                                <div className='progress_bar_main'>
                                    <div className="w-full bg-gray-200 rounded-full h-3">
                                        <div
                                            className={`h-3 rounded-full`}
                                            style={{ width: `${item?.simulated_completion_percentage}%`, background: item?.simulated_session_length_minutes ? '#FFA21D' : item?.simulated_completion_percentage == 100 ? '#16A34A' : '' }}
                                        ></div>
                                    </div>
                                </div>
                            </div>
                            <div className='student_status_sec'>
                                <button style={{ background: item?.simulated_session_length_minutes ? '#496EB4' : item?.simulated_completion_percentage == 100 ? '#16A34A' : '#71757633', color: item?.simulated_session_length_minutes ? '#fff' : item?.simulated_completion_percentage == 100 ? '#fff' : '#717576' }}>{item?.simulated_session_length_minutes ? 'In progress'
                                    : item?.simulated_completion_percentage == 100 ? 'Completed' : 'not started'}</button>
                            </div>
                        </div>
                    </div >
                </Link>
                :
                <div onClick={() => alertPermission()} className='student_application_card_inner cursor-pointer'>
                    <div className='card-body'>
                        <div className='student_application_details'>
                            <div className='student_details'>
                                <div className='student_subject_icon w-32 h-18'>
                                    <img src={item?.icon || fallBackImage} alt={item?.name} className='w-18 h-18 object-cover rounded rounded-lg'
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = fallBackImage;
                                        }}
                                    />
                                </div>
                                <div className='student_subject_details'>
                                    <h4>{item?.name}</h4>
                                    <p>{item?.subject_name}</p>
                                    <p>Location: {item?.location}</p>
                                    <p>Usage Hour: {item?.simulated_usage_hour}</p>
                                </div>
                            </div>
                            <div>
                                <div className='student_educator_details'>
                                    <div className='educator_image_sec w-10 h-10'>
                                        <img src={item?.profile_pic} alt='Image' className='w-10 h-10 object-cover rounded-full' />
                                    </div>
                                    <div className='educator_detail_sec'>
                                        <h4>{item?.createdBy}</h4>
                                        <p>ID: {item?.educator_id}</p>
                                    </div>
                                </div>
                                {item?.simulated_grade_type &&
                                    <div className='student_grade_sec'>
                                        <p>{item?.simulated_grade_type}</p>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className='student_progressBar_sec'>
                            <div className='student_check_application' style={{ justifyContent: item?.simulated_session_length_minutes ? 'space-between' : 'end' }}>
                                {item?.simulated_session_length_minutes && <p>Session Length: {item?.simulated_session_length_minutes}</p>}
                                <p>{item?.simulated_completion_percentage}% Complete</p>
                            </div>
                            <div className='progress_bar_main'>
                                <div className="w-full bg-gray-200 rounded-full h-3">
                                    <div
                                        className={`h-3 rounded-full`}
                                        style={{ width: `${item?.simulated_completion_percentage}%`, background: item?.simulated_session_length_minutes ? '#FFA21D' : item?.simulated_completion_percentage == 100 ? '#16A34A' : '' }}
                                    ></div>
                                </div>
                            </div>
                        </div>
                        <div className='student_status_sec'>
                            <button style={{ background: item?.simulated_session_length_minutes ? '#496EB4' : item?.simulated_completion_percentage == 100 ? '#16A34A' : '#71757633', color: item?.simulated_session_length_minutes ? '#fff' : item?.simulated_completion_percentage == 100 ? '#fff' : '#717576' }}>{item?.simulated_session_length_minutes ? 'In progress'
                                : item?.simulated_completion_percentage == 100 ? 'Completed' : 'not started'}</button>
                        </div>
                    </div>
                </div >
            }
        </>
    )
}
